import { Component, Inject } from '@angular/core';
import {
  MatLegacyDialogRef as MatDialogRef,
  MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA,
} from '@angular/material/legacy-dialog';
import { FormBuilder, Validators } from '@angular/forms';
import { ProjectSettings } from '../../../store/project/models/project-settings.model';

@Component({
  selector: 'app-project-setting-modal',
  templateUrl: 'project-duplicate-modal.component.html',
  styleUrls: ['./project-duplicate-modal.component.scss'],
})
export class ProjectDuplicateModalComponent {
  duplicateForm = this.fb.group({
    projectName: [
      '',
      [
        Validators.required,
        Validators.minLength(5),
        Validators.maxLength(50),
        Validators.pattern(/^[a-zA-Z0-9_-][a-zA-Z0-9_ -]+[a-zA-Z0-9_-]$/),
      ],
    ],
  });

  constructor(
    private fb: FormBuilder,
    public dialogRef: MatDialogRef<ProjectDuplicateModalComponent>,
    @Inject(MAT_DIALOG_DATA) public projectSettings: ProjectSettings,
  ) {
    if (!projectSettings) {
      return;
    }

    this.duplicateForm.get('projectName').setValue(`Copy of ${projectSettings.name}`);
  }

  /**
   * Closes the dialog
   */
  onCancelClick(): void {
    this.dialogRef.close();
  }

  /**
   * Validates the project form fields and prepares a ProjectSettings to pass it back to the caller
   */
  onSaveClick(): void {
    if (this.duplicateForm.invalid) {
      // there might be a better way to show validation errors
      this.duplicateForm.markAsTouched();
      return;
    }

    this.dialogRef.close({
      id: this.projectSettings && this.projectSettings.id,
      name: this.duplicateForm.get('projectName').value,
    });
  }
}
